export const COMPLETION_TRACKER_STATUS = {
	NOT_STARTED: 'not-started',
	IN_PROGRESS: 'in-progress',
	COMPLETE: 'complete',
};

export const RESOURCE_TYPES = {
	SESSION: 'session',
	PAGE: 'page',
	MODULE: 'module',
	SUBMODULE: 'submodule',
	SUBMODULE_CONTENT: 'submodule-content',
	EMBED: 'embed',
	FORM: 'form',
	IMAGE: 'image',
	LINK: 'link',
	MIRO: 'miro',
	POLL: 'poll',
	QUIZ: 'quiz',
	SLIDE: 'slide',
	VIDEO: 'video',
};

export const RESOURCE_ASSOCIATED_OBJECT_TYPES = {
	DISCUSSION_THREAD: 'discussion-thread',
	EVENT: 'event',
	EVENT_STAGE: 'event-stage',
	PRODUCT: 'product',
};
